<template>
	<div class="history-info d-flex justify-content-between">
		<p class="font-italic">
			Version of this article saved on <b>{{ updatedOn }}</b> by
			<b>{{ userName }}</b
			>.
		</p>
		<router-link
			class="hyper-click-primary"
			:to="{ path: '/article-view', query: { id: articleHistory.articleId } }"
		>
			Back to latest version
		</router-link>
	</div>
</template>

<script>
import dayjs from "dayjs";
export default {
	name: "ArticleHistoryHeader",
	props: ["articleHistory"],
	computed: {
		updatedOn: function () {
			return dayjs(this.articleHistory.updatedOn).format(
				"DD MMM YYYY HH:mm:ss"
			);
		},
		userName: function () {
			return this.articleHistory?.userCache?.userName;
		},
	},
};
</script>

<style scoped>
.history-info {
	margin-top: 2.4rem;
	padding-left: 2rem;
	padding-right: 2rem;
	margin-bottom: 0.5rem;
}
</style>